import { Collection, CollectionBannerWidth } from '@app/features/collections/models/collection';

export const cameoBeige: Collection = {
  id: 's-and-p-cameo-beige',
  brandId: 'salt-and-pepper',
  brandName: 'Salt and Pepper',
  icon: 'logo_salt_pepper.png',
  title: 'Cameo Beige',
  subTitle: 'Nieuw Collectie',
  banner: 'cameo-beige/cameo_banner.jpg',
  items: [
    {
      id: 's-and-p-cameo-beige-4',
      collectionImages: [{ image: 'cameo-beige/Cameo_8.jpg', width: CollectionBannerWidth['100%'], fullHeight: false }]
    },
    {
      id: 's-and-p-cameo-beige-2',
      collectionImages: [
        {
          image: 'cameo-beige/Cameo_3.jpg',
          width: CollectionBannerWidth['25%'],
          fullHeight: false,
          items: []
        },
        {
          image: 'cameo-beige/Cameo_4.jpg',
          width: CollectionBannerWidth['75%'],
          fullHeight: false,
          items: []
        }
      ]
    },
    {
      id: 's-and-p-cameo-beige-3',
      collectionImages: [
        { image: 'cameo-beige/Cameo_6.jpg', width: CollectionBannerWidth['33%'], fullHeight: false },
        { image: 'cameo-beige/Cameo_7.jpg', width: CollectionBannerWidth['33%'], fullHeight: false },
        { image: 'cameo-beige/Cameo_5.jpg', width: CollectionBannerWidth['33%'], fullHeight: false }
      ]
    }
  ],
  salesArticleIds: [
    '9cb3a780-7222-4833-8d55-97505526230e',
    '8e5c5c85-7e85-45c4-8bf9-1b3543e915cd',
    'ce110b09-a058-43c7-93fd-c08074cdb1b5',
    '14ee6e6e-5de3-441c-b01c-2c25a176f89d',
    '82491b37-ea0a-4143-b568-95d0a638c47a',
    'c8825f8b-ce37-44f1-8db8-d43c6debfea8',
    'b877eeb7-6368-4d58-96d8-bf8c68d8d5ad',
    'd1166660-9334-40ba-bb87-4dc5138459e8',
    '8443cbef-3983-400f-a090-5a7375d7da6b',
    'e9e806ad-aadf-4d5a-b06e-fb3aa5d9d07b',
    '5fefe481-8a7b-4d0c-9758-e00f7b215115',
    '38404e27-d759-4379-8258-c8eb6af84a1a',
    '82cdc8aa-7665-432b-8cbf-c797a1454a69',
    '97470fb8-f18a-4edf-9151-32f48041b074',
    '3ffd5808-b496-400f-b28d-d435b7fb00a3',
    '6c6e5dc5-97bf-4771-8ae7-8e416dc52817',
    '80feef7f-b947-48c7-984c-a999164a32b8',
    'ec262cf5-5bec-4c75-b54a-5615985fb07c'
  ]
};
